import { useMediaQuery } from '@chakra-ui/react';
import { usePathname } from 'next/navigation';

import { HEDERA } from '@/constants/constants';
import { getCurrentChain } from '@/utils/common';

const useIsMobile = () => {
  const pathname = usePathname();

  const token = getCurrentChain(pathname);
  const [isGreaterThan1280] = useMediaQuery('(min-width: 1280px)');
  return {
    isMobile: !isGreaterThan1280,
    isSupported:
      // TODO: remove this when HEDERA is supported
      // @ts-expect-error - `TOKEN` does not have `HEDERA` yet
      token !== HEDERA,
  };
};

export default useIsMobile;
